/** Booking form builder ng booking action (Actions → booking action → Booking form). */
export const bookingForm = {
  title: "Booking form",
  subtitle: "Ang pupunan ng mga bisita kapag nagbu-book. Idinadagdag ang bawat sagot sa calendar invitation at sa lead.",
  fixed: "Laging tinatanong: buong pangalan at email address (doon ipinapadala ang invitation).",
  askPhone: "Itanong ang mobile number",
  askPhoneHint: "Hindi required sa bisita. Lalabas bilang Phone sa invitation.",
  askNotes: "Magbigay ng notes box",
  askNotesHint: "Isang malayang text box sa dulo ng form.",
  fields: "Inyong mga field",
  empty: "Wala pang field. Magdagdag ng field para itanong ang kumpanya, posisyon, laki ng team at iba pa.",
  addField: "Magdagdag ng field",
  label: "Tanong",
  labelPlaceholder: "hal. Company",
  type: "Uri",
  required: "Required",
  options: "Mga pagpipilian",
  optionsHint: "Isang pagpipilian bawat linya.",
  optionsPlaceholder: "1-25\n26-100\n100+",
  moveUp: "Itaas ang {{name}}",
  moveDown: "Ibaba ang {{name}}",
  remove: "Alisin ang {{name}}",
  fieldN: "Field {{n}}",
  types: {
    text: "Maikling text",
    textarea: "Talata",
    select: "Dropdown",
    checkboxes: "Mga checkbox",
    email: "Email",
    tel: "Telepono",
  },
  preview: "Preview ng invitation",
  previewHint: "Ganito lalabas ang mga detalye sa Google Calendar invitation.",
  previewName: "Juan Dela Cruz",
  previewEmail: "juan@example.com",
  previewPhone: "+63 917 123 4567",
  previewAnswer: "(sagot)",
  save: "I-save ang form",
  saved: "Na-save ang booking form",
  readOnly: "Makikita mo ang form na ito. Hilingin sa admin na baguhin ito.",
  errors: {
    label: "Ilagay ang tanong.",
    labelMax: "Panatilihing mas maikli sa {{count}} character ang tanong.",
    options: "Magdagdag ng kahit isang pagpipilian.",
    optionsMax: "Hanggang {{count}} pagpipilian lang.",
    optionMax: "Panatilihing mas maikli sa {{count}} character ang bawat pagpipilian.",
    duplicateOption: "Isang beses lang dapat lumabas ang bawat pagpipilian.",
    duplicateLabel: "Pareho ang tanong ng dalawang field.",
    tooMany: "Hanggang {{count}} field lang ang maidadagdag.",
  },
} as const;
